<template>
    <DRow>
        <DCol>
            <DTabs class="mb-3">
                <DTabItem
                    id="communications-tab-internal"
                    :route-url="route('customers.customers.communications.index', {customer: customer.id})"
                    :active="['customers.customers.communications.index'].includes(route().current())"
                    :label="__('customers.communications.tabs.internal')"
                />
                <DTabItem
                    id="communications-tab-messenger"
                    :route-url="route('customers.customers.communications.messenger.index', {customer: customer.id})"
                    :active="['customers.customers.communications.messenger.index'].includes(route().current())"
                    :label="__('customers.communications.tabs.messenger')"
                />
            </DTabs>
        </DCol>
    </DRow>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'

defineProps({
    customer: {
        type: Object,
        default: () => { return {} }
    }
})
</script>
